module.exports = __webpack_public_path__ + "static/media/logo.2c9be751.png";